import api from './api';
import {
  InfoResponse,
  HomeResponse,
  AnniversaryResponse,
  IpResponse,
  WorkshopResponse,
  ComicResponse
} from './responseType';

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const mock = require('./mock').default;
  mock();
}

export default {
  getInfo: (params: { region: string; lang: string; accessToken?: string }) => api<InfoResponse>('get', '/info', params),
  getHome: (params: { region: string; lang: string; accessToken?: string }) => api<HomeResponse>('get', '/home', params),
  getAnniversary: (params: { region: string; lang: string; accessToken?: string }) => api<AnniversaryResponse>('get', '/anniversary', params),
  getIp: (params: { region: string; lang: string; accessToken?: string }) => api<IpResponse>('get', '/ip', params),
  getWorkshop: (params: { region: string; lang: string; accessToken?: string }) => api<WorkshopResponse>('get', '/event', params),
  getComic: (params: { region: string; lang: string; accessToken?: string }) => api<ComicResponse>('get', '/comic', params),
};
